import type { Shadows } from "@mui/material/styles";

const shadowColor = "rgba(0,0,0,0.10)";

export const shadows: Shadows = [
  // Slots 0-5 define elevations 0 through `xl`. Slot 6 holds the X-axis
  // variant of `shadows[1]` (offsets right instead of down) for elements
  // where a downward shadow reads as a bottom border, e.g. the mobile top
  // bar. The remaining slots are required by Material UI but unused.
  "none",
  `0px 4px 8px ${shadowColor}`,
  `0px 6px 12px ${shadowColor}`,
  `0px 8px 16px ${shadowColor}`,
  `0px 10px 20px ${shadowColor}`,
  `0px 12px 24px ${shadowColor}`,
  `4px 0px 8px ${shadowColor}`,
  `0 0 0 0 ${shadowColor}`,
  `0 0 0 0 ${shadowColor}`,
  `0 0 0 0 ${shadowColor}`,
  `0 0 0 0 ${shadowColor}`,
  `0 0 0 0 ${shadowColor}`,
  `0 0 0 0 ${shadowColor}`,
  `0 0 0 0 ${shadowColor}`,
  `0 0 0 0 ${shadowColor}`,
  `0 0 0 0 ${shadowColor}`,
  `0 0 0 0 ${shadowColor}`,
  `0 0 0 0 ${shadowColor}`,
  `0 0 0 0 ${shadowColor}`,
  `0 0 0 0 ${shadowColor}`,
  `0 0 0 0 ${shadowColor}`,
  `0 0 0 0 ${shadowColor}`,
  `0 0 0 0 ${shadowColor}`,
  `0 0 0 0 ${shadowColor}`,
  `0 0 0 0 ${shadowColor}`,
] as const;
